import { Logbar } from 'components/elements/logBar/LogBar';
import React, { useEffect, useState } from 'react';

const LogBarView = (props) => {
  const [ width, setWidth ] = useState(0);
  const min = 1;
  const max = 2000;
  const scale = [
    6,
    10,
    100,
    1000,
    2000
  ];
 
  const clamp = (val, min, max) => {
    return val > max ? max : val < min ? min : val;
  };

  const advance = () => {
    setWidth((w) => clamp(w + 50, min, max));
  };

  // useEffect(() => {
  //   let interval = setInterval(() => {
  //     advance();
  //   }, 100);

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  return (
    <div>
      <Logbar 
        value={props.value}
        min={min}
        max={max}
        scale={scale}/>    
    </div>
  );
};

export default LogBarView;
